<template>
  <div class="dialog-container wt-dialog-container">
    <div v-loading="isLopperDetailLoading">
      <wt-detail-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm">
        <template slot="looperType">
          <el-select v-model="detailFormData.looperType" placeholder="请选择链接方式" @change="looperTypeChangeAndRefresh">
            <el-option v-for="(dataItem, dataIndex) in looperTypeData" :key="dataIndex" :label="dataItem.label"
                       :value="dataItem.value"></el-option>
          </el-select>
        </template>
        <template slot="associatedId">
          <el-button type="primary" @click="associatedChoose">选择</el-button>
          <el-table :data="chooseData" style="width: 100%">
            <el-table-column v-if="detailFormData.looperType === 3" key="goodsNo" prop="goodsNo" label="商品编号"></el-table-column>
            <el-table-column v-if="detailFormData.looperType === 3" key="cover" prop="cover" label="商品图片" width="180">
              <template slot-scope="data">
                <img class="table-img" v-if="data.row.cover && data.row.cover.length > 0" :src="imgUrl + data.row.cover.split(',')[0]">
              </template>
            </el-table-column>
            <el-table-column v-if="detailFormData.looperType === 3" key="title" prop="title" label="商品标题"></el-table-column>
            <el-table-column v-if="detailFormData.looperType === 3" key="integral" prop="integral" label="积分"></el-table-column>
            <el-table-column v-if="detailFormData.looperType === 2" key="title2" prop="title" label="资讯标题"></el-table-column>
            <el-table-column v-if="detailFormData.looperType === 2" key="coverPath" prop="coverPath" label="资讯图片" width="180">
              <template slot-scope="data">
                <img class="table-img" v-if="data.row.coverPath && data.row.coverPath.length > 0" :src="imgUrl + data.row.coverPath.split(',')[0]">
              </template>
            </el-table-column>
            <el-table-column v-if="detailFormData.looperType === 2" key="typeName" prop="typeName" label="资讯标签"></el-table-column>
            <el-table-column prop="action" label="操作">
              <template slot-scope="data">
                <wt-auth class="search-form-btn">
                  <el-button style="background: transparent; border: 0; font-weight: bold; color: #F56C6C;" size="mini" type="danger" @click="toClickAction(data.row)">删除</el-button>
                </wt-auth>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </wt-detail-form-section>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
    <el-dialog
      title=""
      :visible.sync="goodsObj.visible"
      width="60%"
      :modal="false"
      append-to-body
      :show-close="false"
      :before-close="handleDialogClose">
      <div class="dialog-input-card">
        <wt-form-table :key="1" :form.sync="goodsForm" >
          <wt-form-table-list :key="1" ref="goodsTableRef" slot="wtFormTableList" :form.sync="goodsForm">
            <template slot="cover" slot-scope="data">
              <img class="table-img" v-if="data.row.cover && data.row.cover.length > 0" :src="imgUrl + data.row.cover.split(',')[0]">
            </template>
           </wt-form-table-list>
        </wt-form-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleDialogClose">取 消</el-button>
        <el-button size="small" type="primary" @click="handleGoodsChoose">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="infoObj.visible"
      width="60%"
      :modal="false"
      append-to-body
      :show-close="false"
      :before-close="handleDialogClose">
      <div class="dialog-input-card">
        <wt-form-table :key="2" :form.sync="infoForm" >
          <wt-form-table-list :key="2" slot="wtFormTableList" :form.sync="infoForm">
            <template slot="coverPath" slot-scope="data">
              <img class="table-img" v-if="data.row.coverPath && data.row.coverPath.length > 0" :src="imgUrl + data.row.coverPath.split(',')[0]">
            </template>
           </wt-form-table-list>
        </wt-form-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleDialogClose">取 消</el-button>
        <el-button size="small" type="primary" @click="handleInfoChoose">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Lopper-edit',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      formCode: 'MODULES_LOPPER',
      isSubmitLoading: false,
      formUpdateUrl: '/modules/lopper/lopperUpdate',
      formAddUrl: '/modules/lopper/lopperAdd',
      detailFormButtons: {
        title: '详情',
        elements: [{ name: '提交', key: 'ADD', action: 'ADD', className: 'primary', hidden: this.componentType !== 'add' },
          { name: '提交', key: 'EDIT', action: 'EDIT', className: 'primary', hidden: this.componentType !== 'edit' },
          { name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      detailForm: {
        title: '基本信息',
        className: 'wt-section-long-content',
        elements: [
          { name: '标题',
            key: 'name',
            type: 'text',
            required: true,
            disabled: false,
            className: 'wt-col-12',
            rules: [
              { min: 1, max: 50, message: '标题长度不能超过50', trigger: 'blur' }
            ] },
          { name: '图片', key: 'coverPathList', type: 'image', required: true, disabled: false, className: 'wt-col-12', limit: 1, markText: '上传图片尺寸372x460px' },
          { name: '排序', key: 'orderNum', type: 'number', required: true, disabled: false, className: 'wt-col-6' },
          { name: '链接方式', key: 'looperType', type: 'custom', disabled: false, required: true, className: 'wt-col-6' },
          { name: '链接', key: 'associatedId', type: 'text', required: true, disabled: false, className: 'wt-col-12' }]
      },
      looperTypeData: [
        { label: '自定义', value: 1 },
        { label: '关联资讯', value: 2 },
        { label: '关联商品', value: 3 },
        { label: '外部链接', value: 4 }
      ],
      chooseData: [],
      goodsObj: {
        visible: false
      },
      infoObj: {
        visible: false
      },
      goodsForm: { //  表单数据
        isFormLoading: false,
        formComponent: { list: { type: 'default', value: '/modules/goods/goodsList' }},
        formInputsData: [{ name: '商品编号', key: 'goodsNo', value: '', type: 'text' }],
        formButtonsData: [],
        formTableData: [
          { name: '商品编号', key: 'goodsNo', type: 'text' },
          { name: '商品图片', key: 'cover', type: 'custom' },
          { name: '商品名称', key: 'title', type: 'text' },
          { name: '积分', key: 'integral', type: 'text' }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: true, index: true, buttonHidden: true }
      },
      infoForm: { //  表单数据
        isFormLoading: false,
        formComponent: { list: { type: 'default', value: '/modules/information/informationList' }},
        formInputsData: [{ name: '资讯标题', key: 'title', value: '', type: 'text' }],
        formButtonsData: [],
        formTableData: [
          { name: '资讯标题', key: 'title', type: 'text' },
          { name: '资讯图片', key: 'coverPath', type: 'custom' },
          { name: '资讯标签', key: 'typeName', type: 'text' }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: true, index: true, buttonHidden: true }
      }
    }
  },
  created() {
    if (this.componentType === 'add') {
      this.detailFormData.looperType = 4
      this.looperTypeChange(this.detailFormData.looperType)
    }
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      } else if (item.action === 'ADD') {
        this.onAdd()
      } else if (item.action === 'EDIT') {
        this.onSave()
      }
    },
    onAdd() {
      const that = this
      this.$wtUtil.validateDetailFormsAndConfirm(this, '是否提交').then(() => {
        that.requestAddLopperDetail()
      }).catch(() => {
      })
    },
    onSave() {
      const that = this
      this.$wtUtil.validateDetailFormsAndConfirm(this, '是否提交').then(() => {
        that.requestUpdateLopperDetail()
      }).catch(() => {
      })
    },
    associatedChoose() {
      if (this.detailFormData.looperType === 2) {
        this.infoObj.visible = true
      }
      if (this.detailFormData.looperType === 3) {
        this.goodsObj.visible = true
      }
    },
    handleDialogClose() {
      if (this.detailFormData.looperType === 2) {
        this.infoObj.visible = false
      }
      if (this.detailFormData.looperType === 3) {
        this.goodsObj.visible = false
      }
    },
    handleGoodsChoose() {
      if (this.goodsForm.formSelectedList && this.goodsForm.formSelectedList.length > 0) {
        const _chooseDataIds = []
        for (const item of this.chooseData) {
          _chooseDataIds.push(item.id)
        }
        for (const item of this.goodsForm.formSelectedList) {
          if (_chooseDataIds.indexOf(item.id) === -1) {
            this.chooseData.push(item)
          }
        }
      }
      this.goodsObj.visible = false
    },
    handleInfoChoose() {
      if (this.infoForm.formSelectedList && this.infoForm.formSelectedList.length > 0) {
        const _chooseDataIds = []
        for (const item of this.chooseData) {
          _chooseDataIds.push(item.id)
        }
        for (const item of this.infoForm.formSelectedList) {
          if (_chooseDataIds.indexOf(item.id) === -1) {
            this.chooseData.push(item)
          }
        }
      }
      this.infoObj.visible = false
    },
    toClickAction(row) {
      const _index = this.chooseData.indexOf(row)
      this.chooseData.splice(_index, 1)
    },
    /*  ------------------------- 网络请求  -------------------------  */
    requestAddLopperDetail() {
      const that = this
      const sendData = JSON.parse(JSON.stringify(this.detailFormData))
      sendData.coverPath = this.detailFormData.coverPathList[0].fileUrl
      this.$wtUtil.postFormData({
        url: this.formAddUrl,
        formData: sendData,
        isLoading: this.isSubmitLoading
      }).then(resp => {
        that.$message({ message: '保存成功', type: 'success' })
        that.$emit('on-dialog-action', 'close')
        that.$emit('on-dialog-action', 'refresh')
      })
    },
    requestUpdateLopperDetail() {
      const that = this
      const sendData = JSON.parse(JSON.stringify(this.detailFormData))
      sendData.coverPath = this.detailFormData.coverPathList[0].fileUrl
      this.$wtUtil.postFormData({
        url: this.formUpdateUrl,
        formData: sendData,
        isLoading: this.isSubmitLoading
      }).then(resp => {
        that.$message({ message: '保存成功', type: 'success' })
        that.$emit('on-dialog-action', 'close')
        that.$emit('on-dialog-action', 'refresh')
      })
    },
    onWtDialogClose() {
      this.$emit('on-dialog-action', 'close')
    },
    looperTypeChangeAndRefresh(val) {
      if (val === 1) {
        this.detailFormData.content = ''
      }
      if (val === 2) {
        this.chooseData = []
      }
      if (val === 3) {
        this.chooseData = []
      }
      if (val === 4) {
        this.detailFormData.content = ''
      }
      this.looperTypeChange(val)
    },
    looperTypeChange(val) {
      if (val === 1) {
        this.detailForm.elements[4].name = '内容'
        this.detailForm.elements[4].type = 'editor'
        this.detailForm.elements[4].key = 'content'
      }
      if (val === 2) {
        this.detailForm.elements[4].name = '资讯'
        this.detailForm.elements[4].type = 'custom'
        this.detailForm.elements[4].key = 'associatedId'
      }
      if (val === 3) {
        this.detailForm.elements[4].name = '商品'
        this.detailForm.elements[4].type = 'custom'
        this.detailForm.elements[4].key = 'associatedId'
      }
      if (val === 4) {
        this.detailForm.elements[4].name = '链接'
        this.detailForm.elements[4].type = 'text'
        this.detailForm.elements[4].key = 'content'
      }
    }
  },
  computed: {
    ...mapState({
      isLopperDetailLoading: state => state.lopper.isLopperDetailLoading,
      detailFormData: state => state.lopper.lopperDetailData
    })
  },
  watch: {
    chooseData(val) {
      if (this.detailFormData.looperType === 2 || this.detailFormData.looperType === 3) {
        const _chooseDataIds = []
        for (const item of val) {
          _chooseDataIds.push(item.id)
        }
        this.detailFormData.associatedId = _chooseDataIds.join(',')
      }
    },
    isLopperDetailLoading(val) {
      if (!val) {
        if (this.componentType === 'edit') {
          this.detailFormData.coverPathList = [{ fileUrl: this.detailFormData.coverPath }]
          console.log(2233)
          this.looperTypeChange(this.detailFormData.looperType)
        }
        if (this.detailFormData.looperType === 2) {
          this.chooseData = [{
            id: this.detailFormData.associatedId * 1,
            coverPath: this.detailFormData.infomationCover,
            title: this.detailFormData.infomationTitle,
            typeName: this.detailFormData.infomationTypeName
          }]
        }
        if (this.detailFormData.looperType === 3) {
          this.chooseData = [{
            id: this.detailFormData.associatedId * 1,
            goodsNo: this.detailFormData.goodsNo,
            cover: this.detailFormData.goodsCover,
            title: this.detailFormData.goodsTitle,
            integral: this.detailFormData.goodsIntegral
          }]
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
